import Plyr from 'plyr/dist/plyr.polyfilled.js';

import '../../sass/blocks/video.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $videos = document.querySelectorAll('.video');

    if (!$videos) return;

    $videos.forEach($video => {
        let video = null;

        const $videoPlayerWrap = $video.querySelector('.video__player-wrap');
        const $videoPlayer = $video.querySelector('.video__player');
        const $playBtn = $video.querySelector('.video__play-btn');

        const initVideo = () => {
            if (!$videoPlayerWrap || !$videoPlayer) return;

            const autoplay = $videoPlayerWrap.hasAttribute('data-autoplay');

            const { y } = $video.getBoundingClientRect();
            
            video = new Plyr($videoPlayer, {
                controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                muted: autoplay,
                autoplay: y <= window.innerHeight && y + $videoPlayerWrap.clientHeight > 0
            });

            if ($playBtn) {
                $playBtn.addEventListener('click', () => {
                    video.play();
                });
            }

            if (autoplay) {
                const playOnScreenVideo = (muted = false) => {
                    if (!video) return;
                    
                    const { y } = $videoPlayerWrap.getBoundingClientRect();

                    video.muted = muted;

                    // If on screen, play video
                    if (y <= window.innerHeight && y + $videoPlayerWrap.clientHeight > 0 && noMotionPreference.matches) {
                        if (video.currentTime === 0) {
                            video.play().catch(() => {
                                video.muted = true;
                                video.play();
                            });
                        }
                    } else {
                        video.pause();
                    }
                };

                window.addEventListener('scroll', () => {
                    requestAnimationFrame(() => {
                        playOnScreenVideo();
                    });
                });

                window.addEventListener('load', () => {
                    playOnScreenVideo(true)
                });

                playOnScreenVideo();
            }
        };

        initVideo();
    });
})();
